'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _DashedLabel = require('./DashedLabel');

var _DashedLabel2 = _interopRequireDefault(_DashedLabel);

var _PlainLabel = require('./PlainLabel');

var _PlainLabel2 = _interopRequireDefault(_PlainLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DateLabel(_ref) {
  var children = _ref.children,
      useDashedLabel = _ref.useDashedLabel;

  if (useDashedLabel) {
    return _react2.default.createElement(
      _DashedLabel2.default,
      null,
      children
    );
  }

  return _react2.default.createElement(
    _PlainLabel2.default,
    null,
    children
  );
}

DateLabel.propTypes = {
  children: _react.PropTypes.node.isRequired,
  useDashedLabel: _react.PropTypes.bool.isRequired
};

exports.default = DateLabel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-messages/static-1.640/js/label/DateLabel.js
// module id = 1144
// module chunks = 2 3